import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialAuth = () => {
  const navigate = useNavigate();
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'bg-white hover:bg-gray-50 text-gray-700 border border-border'
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'Facebook',
      color: 'bg-teal-600 hover:bg-teal-700 text-white'
    }
  ];

  const handleSocialAuth = async (providerId) => {
    setLoadingProvider(providerId);
    
    // Simulate social authentication
    setTimeout(() => {
      // Mock successful social login
      localStorage.setItem('user', JSON.stringify({
        id: 2,
        email: 'social.user@example.com',
        name: 'Social User',
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
        provider: providerId
      }));
      navigate('/user-dashboard');
      setLoadingProvider(null);
    }, 2000);
  };

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="mt-6 space-y-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            fullWidth
            onClick={() => handleSocialAuth(provider?.id)}
            loading={loadingProvider === provider?.id}
            disabled={loadingProvider !== null}
            className={`${provider?.color} transition-micro`}
          >
            <div className="flex items-center justify-center space-x-3">
              <Icon name={provider?.icon} size={20} />
              <span>
                {loadingProvider === provider?.id 
                  ? `Connecting to ${provider?.name}...` 
                  : `Continue with ${provider?.name}`
                }
              </span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialAuth;